<template>
  <div class="add-clock-page">
    <main class="form-content">
      <div class="form-row">
        <span class="form-label">做钟类型：</span>
        <div class="field-box readonly-field">{{ clockTypeLabel }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">技师号：</span>
        <div class="field-box readonly-field">{{ form.technicianCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">项目名称：</span>
        <button
          type="button"
          class="field-box select-field"
          @click="showProjectPicker = true"
        >
          <span :class="{ placeholder: !form.projectName }">
            {{ form.projectName || "请选择项目" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>
      <div class="form-row">
        <span class="form-label">手牌号：</span>
        <div class="field-box readonly-field">{{ form.handCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">房间号：</span>
        <div class="field-box readonly-field">{{ form.roomName }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">做钟数量：</span>
        <div class="field-box number-stepper">
          <button
            type="button"
            :disabled="form.clockCount <= 1"
            @click="changeClockCount(-1)"
          >−</button>
          <input
            v-model.number="form.clockCount"
            type="number"
            inputmode="numeric"
            min="1"
            max="20"
            step="1"
            @blur="normalizeClockCount"
          />
          <button
            type="button"
            :disabled="form.clockCount >= 20"
            @click="changeClockCount(1)"
          >＋</button>
        </div>
      </div>
    </main>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">
        取消
      </button>
      <button type="button" class="footer-button save-button" @click="handleSave">
        确认加钟
      </button>
    </footer>

    <project-select-popup
      v-model="showProjectPicker"
      :projects="projectOptions"
      :selected-id="form.projectId"
      @confirm="confirmProject"
    />
  </div>
</template>

<script>
import ProjectSelectPopup from "@/components/jishi/ProjectSelectPopup";

export default {
  name: "JiShiAddClock",
  components: {
    ProjectSelectPopup,
  },
  data() {
    return {
      showProjectPicker: false,
      form: {
        id: "",
        clockType: "queue",
        technicianCode: "007",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
      projectOptions: [
        { id: "6001", name: "精油按摩", price: 299, unit: "成人" },
        { id: "6002", name: "颈肩按摩", price: 398, unit: "1大1小" },
        { id: "6003", name: "足底按摩", price: 668, unit: "成人" },
        { id: "6004", name: "全身推拿", price: 68, unit: "成人" },
        { id: "6005", name: "艾灸养生", price: 368, unit: "成人" },
        { id: "6006", name: "特价按摩", price: 168, unit: "成人" },
      ],
    };
  },
  computed: {
    /**
     * 将当前做钟类型转换为只读中文名称。
     * 支持英文状态键和接口直接返回中文两种格式，无法识别的值原样展示。
     *
     * @returns {string} 当前做钟类型名称。
     */
    clockTypeLabel() {
      const clockTypeMap = {
        queue: "排钟",
        point: "点钟",
        select: "选钟",
        call: "Call钟",
      };
      return clockTypeMap[this.form.clockType] || this.form.clockType || "-";
    },
  },
  created() {
    this.initializeForm();
  },
  methods: {
    /**
     * 使用路由参数初始化当前做钟数据。
     * 只覆盖路由中存在且非空的字段，并将做钟数量转换为数字；技师号、手牌号、
     * 房间等字段虽然通过路由载入，但在页面上保持只读。
     */
    initializeForm() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      Object.keys(this.form).forEach((key) => {
        if (query[key] !== undefined && query[key] !== "") {
          this.form[key] =
            key === "clockCount" ? Number(query[key]) : query[key];
        }
      });
    },
    /**
     * 接收项目公共组件确认的完整对象，更新唯一允许修改的项目字段。
     *
     * @param {Object} project 已确认项目，包含 id 和 name。
     */
    confirmProject(project) {
      if (!project) {
        return;
      }
      this.form.projectId = project.id;
      this.form.projectName = project.name;
    },
    /**
     * 按整数步长修改本次加钟数量，并将结果限制在 1 到 20 之间。
     *
     * @param {number} direction 1 表示增加，-1 表示减少。
     */
    changeClockCount(direction) {
      const currentValue = Number(this.form.clockCount) || 1;
      const nextValue = currentValue + direction;
      this.form.clockCount = Math.min(20, Math.max(1, nextValue));
    },
    /**
     * 修正用户手动输入的做钟数量。
     * 非数字恢复为 1，超出范围时截取到 1 至 20，并四舍五入为整数。
     */
    normalizeClockCount() {
      const inputValue = Number(this.form.clockCount);
      const safeValue = Number.isFinite(inputValue) ? inputValue : 1;
      this.form.clockCount = Math.round(Math.min(20, Math.max(1, safeValue)));
    },
    /**
     * 取消本次加钟操作并返回上一页；没有浏览历史时保持当前页面。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 校验并输出加钟数据。
     * 当前页面通过 add-clock 事件将完整表单交给父页面或接口层，接口成功前不会
     * 修改原做钟记录，避免保存失败时界面与后台数据不一致。
     */
    handleSave() {
      this.normalizeClockCount();
      if (!this.form.projectId) {
        this.$toast("请选择项目");
        return;
      }
      this.$emit("add-clock", { ...this.form });
      this.$toast.success("保存成功");
    },
  },
};
</script>

<style scoped lang="scss">
.add-clock-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.form-content {
  padding: 34px 34px 0 28px;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  margin-left: 20px;
  padding: 0 24px;
  flex: 1;
  align-items: center;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  box-shadow: 0 1px 4px rgba(117, 101, 70, 0.06);
  font-size: 25px;
}

.readonly-field {
  color: #887c68;
  background: #f8f5ef;
  user-select: none;
}

.select-field {
  justify-content: space-between;
  text-align: left;

  .placeholder {
    color: #bbb3a6;
  }
}

.arrow-icon {
  width: 10px;
  height: 10px;
  border-top: 2px solid #b09a6d;
  border-right: 2px solid #b09a6d;
  transform: rotate(45deg);
}

.number-stepper {
  padding: 0;
  justify-content: space-between;
  overflow: hidden;

  button {
    width: 72px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: #faf6ef;
    font-size: 31px;

    &:disabled {
      color: #d6cec0;
    }
  }

  input {
    width: 100px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: transparent;
    font-size: 26px;
    text-align: center;
    outline: 0;
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
    }
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  padding: 12px 30px env(safe-area-inset-bottom);
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}
</style>
